/* Set up gate form, if any */
const initPlayer = function () {
	const urlParameters = new URLSearchParams(window.location.search);
	const bypassed = Boolean(urlParameters.get('g'));

	/* Check if we're gated */
	const gate = document.querySelector('#page-video #video-gate');

	if (gate && !bypassed) {
		/* Hide video, display gate form */
		document.querySelector('#page-video #video-player')?.remove();
		document.querySelector('#page-video #video-meta')?.remove();

		/* Set gate form params dynamically */
		document.querySelector('#page-video #video-gate form')?.removeAttribute('target');
	} else {
		document.querySelector('#page-video #video-gate')?.classList.add('is-hidden');
		document.querySelector('#page-video #video-player')?.classList.remove('is-hidden');
		document.querySelector('#page-video #video-meta')?.classList.remove('is-hidden');
	}
};

/* Set up transcript interactivity */
const initCaptions = function (videoPlayer) {
	const wistiaId = videoPlayer.dataset.wistiaId;

	const captions = document.querySelectorAll('#video-captions span');

	window._wq = window._wq || [];
	window._wq.push({ id: wistiaId, onReady(video) {
		/* Highlight the caption where time is between start and end */
		video.on('timechange', time => {
			document.querySelector('#video-captions span.is-active')?.classList?.remove('is-active');
			for (const caption of captions) {
				if (time >= caption.dataset.start && time < caption.dataset.end) {
					caption.classList.add('is-active');
				}
			}
		});

		/* Set the video time when clicking a caption */
		for (const caption of captions) {
			caption.addEventListener('click', () => {
				video.time(caption.dataset.start);
				video.play();
			});
		}
	} });
};

document.addEventListener('DOMContentLoaded', () => {
	const videoPlayer = document.querySelector('#page-video #video-player');

	if (videoPlayer) {
		initPlayer();
		initCaptions(videoPlayer);
	}
});
